import React, { useContext } from 'react';
import LineItem from '../models/LineItem'
import Registration from '../models/Registration'

const RegistrationsContext = React.createContext();

const RegistrationsProvider = (props) => {

  const lineItems = (props && props.value || []).map((l) => LineItem(l))
  const registrations = lineItems.map((l) => Registration(l))
  return (
    <RegistrationsContext.Provider value={registrations}>
      {props.children}
    </RegistrationsContext.Provider>
  );
};

export { RegistrationsContext, RegistrationsProvider}
